<template>
  <div class="container-fluid">
    <breadcrumbs class="bg-light text-muted"></breadcrumbs>

    <div class="p-5 bg-white rounded">
      <integration-header class="row mb-5"></integration-header>

      <div class="row">
        <div class="col-12">
          <integration-info></integration-info>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/common/Breadcrumbs'
  import IntegrationHeader from '@/components/administration/integration/detail/IntegrationHeader'
  import IntegrationInfo from '@/components/administration/integration/detail/IntegrationInfo'
  import {prepareIntegration} from '@/components/administration/channel/router-guard-handler'
  import eventBus from '@/services/event-bus/event-bus'

  export default {
    metaInfo() {
      return {
        title: this.integration.name
      }
    },

    components: {
      'breadcrumbs': Breadcrumbs,
      'integration-header': IntegrationHeader,
      'integration-info': IntegrationInfo
    },

    store: {
      integration: 'administration.integrationDetail.integration'
    },

    methods: {
      updateIntegration(integration) {
        log.debug('integration-old', this.integration)
        log.debug('integration-new', integration)
        this.integration = integration
      }
    },

    created() {
      eventBus.$on('update-integration', this.updateIntegration)
    },

    beforeRouteEnter(to, from, next) {
      prepareIntegration(to, next, (vm, integration) => {
        vm.integration = integration
      })
    }
  }
</script>
